import * as React from "react";

function SvgNote(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      width={props.size}
      height={props.size}
      style={{
        msTransform: "rotate(360deg)",
        WebkitTransform: "rotate(360deg)",
      }}
      viewBox="0 0 36 36"
      transform="rotate(360)"
      {...props}
    >
      <path
        d="M28 30H6V8h13.22l2-2H6a2 2 0 00-2 2v22a2 2 0 002 2h22a2 2 0 002-2V15l-2 2z"
        className="note_svg__clr-i-outline note_svg__clr-i-outline-path-1"
        fill="#626262"
      />
      <path
        d="M33.53 5.84l-3.37-3.37a1.61 1.61 0 00-2.28 0L14.17 16.26l-1.11 4.81A1.61 1.61 0 0014.63 23a1.69 1.69 0 00.37 0l4.85-1.07L33.53 8.12a1.61 1.61 0 000-2.28zM18.81 20.08l-3.66.81.85-3.63L26.32 6.87l2.82 2.82zM30.27 8.56l-2.82-2.82L29 4.16 31.84 7z"
        className="note_svg__clr-i-outline note_svg__clr-i-outline-path-2"
        fill="#626262"
      />
      <path fill="rgba(0, 0, 0, 0)" d="M0 0h36v36H0z" />
    </svg>
  );
}

export default SvgNote;

